import { useEffect, useState } from 'react';

const preload = (url: string) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(url);
    img.onerror = () => reject(url);
    img.src = url;
  }).catch((error) => {
    console.error('Error preloading image at url', url, error);
    return null;
  });

const usePreloadImages = (paths: string[]) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    Promise.all(paths.map(preload)).then(() => setReady(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...paths]);

  return ready;
};

export default usePreloadImages;
